import { render, staticRenderFns } from "./UserPhoneLogin.vue?vue&type=template&id=2d832325&scoped=true&"
import script from "./UserPhoneLogin.vue?vue&type=script&lang=js&"
export * from "./UserPhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneLogin.vue?vue&type=style&index=0&id=2d832325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d832325",
  null
  
)

export default component.exports